/**
 * Dokupowane moduły. Wartości muszą odpowiadać enumowi AppExtensions w BE
 * (Kwantum.LegalMail.Data/AppPrivileges.cs): Tasks=2 (Czynności), Workspace=3 (Zespół).
 */
export enum EAppExtension {
  Tasks = 2,
  Workspace = 3,
}
